import React from 'react';
import App from './App';
import 'semantic-ui-css/semantic.min.css';
import { createRoot } from 'react-dom/client';
import { ComponentErrorBoundary } from './utilities/ComponentErrorBoundary';
import { msalInstance } from './utilities/LoginUtils'

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <ComponentErrorBoundary>
      <App instance={msalInstance} />
    </ComponentErrorBoundary>
  </React.StrictMode>
);
